export const isSSR = typeof window === 'undefined'
export const HTMLElement = isSSR
  ? /* istanbul ignore next */ Object
  : window.HTMLElement

export const File = isSSR ? /* istanbul ignore next */ Object : window.File
